export default __webpack_public_path__ + "static/media/eye.94412c22.svg";